import { ceres_api } from "@/axios-config.js"

const Roles = {
    getRoles() {
        return ceres_api.get("/roles")
    }
}

export default Roles
